ymaps.ready(init);

function init() {
    document.querySelectorAll("[data-map]").forEach((block) => {
        const json = JSON.parse(block.dataset.map);

        const myMap = new ymaps.Map(block, {
            center: json.center,
            zoom: json.zoom,
            controls: []
        });

        // myMap.behaviors.disable('scrollZoom');
        // myMap.behaviors.disable('drag');

        myMap.controls.add('zoomControl', {
            size: 'small',
            float: 'none',
            position: {
                top: 20,
                right: 20
            }
        });

        const myPlacemark = new ymaps.Placemark(
            json.coord,
            {
                hintContent: "",
                balloonContent: "",
            },
            {
                iconLayout: "default#image",
                iconImageHref: json.marker.icon,
                iconImageSize: json.marker.size,
                iconImageOffset: json.marker.offset,
            }
        );

        myMap.geoObjects.add(myPlacemark);
    });
}
